import { Component, NgZone, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../service/util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UIRoutes } from '../UIRoutes';

// This lets me use jquery
declare var $: any;

@Component({
  selector: 'app-payment-link',
  templateUrl: './payment-link.component.html',
  styleUrls: ['./payment-link.component.css']
})


export class PaymentLinkComponent implements OnInit {
  confirmationId: string;
  accessToken: string;
  bookings = [];
  isLoading = true;
  bookingMessage = '';
  groupedSlots = [];
  groupedAddOns = [];
  products = [];
  venues = [];
  formattedExpiry;
  tenant;
  user;
  isPhoneInputRequired = false;
  showPhoneError = false;
  isBillDeskPaymentActive = false;
  isPaymentPending = false;
  totalPlatformFeeEndUser = 0;
  subTotal = 0;
  discountAmount = 0;
  totalSum = 0;
  selectedSlotsMap;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    private utilService: UtilService,
    private zone: NgZone) {


  }

  ngOnInit() {
    console.log("In ngOnInit function inside payment confirmation component");
    const url = new URL(window.location.href);
    const value = url.searchParams.get("bookingId");
    console.log(value);

    this.authService.getBookingByConfirmationId(value).subscribe(
      (response: any) => {
        this.isLoading = false;
        let bookingStatus = '';
        console.log("Booking response => ", response);
        if (!Array.isArray(response) || response.length === 0) {
          this.bookings = [];
          this.groupedSlots = [];
          this.groupedAddOns = [];
          return;
        }

        const currentStatus = String(response[0].bookingStatus || '').toLowerCase().replace(/\s+/g, '');
        if (currentStatus !== 'waitingforpayment') {
          this.bookingMessage = currentStatus === 'cancelled' || currentStatus === 'canceled'
            ? 'This booking has been cancelled by the admin.'
            : 'This booking is no longer available for payment.';
          return;
        }

        if (response[0].bookingStatus == "Booked") {
          bookingStatus = "Successful";
        } else if (response[0].bookingStatus == "WaitingForPayment") {
          bookingStatus = "WaitingForPayment";
        } else {
          bookingStatus = "Failed";
        }
        console.log("Booking is " + bookingStatus + " for confirmationId: " + response[0].confirmationId);
        this.bookings = response;
        this.updateBookingGroups();
        if (this.bookings[0].config) {
          const config = JSON.parse(this.bookings[0].config);
          const createdDate = new Date(this.bookings[0].createdAt);
          const expiryMinutes = config.expiryDuration;
          if (expiryMinutes === -1) {
            this.formattedExpiry = "";
          } else {
            const expiryDate = new Date(createdDate.getTime() + expiryMinutes * 60 * 1000);
            const formattedExpiry = expiryDate.toISOString();
            console.log("Expiry Time:", formattedExpiry);
            const expiryStr = expiryDate.toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            this.formattedExpiry = expiryStr;
          }
        }

        let totalAmount = 0;
        let totalPlatformFeeEndUser = 0;

        this.bookings.forEach(b => {
          totalAmount += Number(b.amount) || 0;
          totalPlatformFeeEndUser += Number(b.platformFeeEndUser) || 0;
        });

        // Order-level discount (same value repeated on each slot; read once).
        const discount = Number(this.bookings[0].discountAmount) || 0;

        this.subTotal = totalAmount;
        this.discountAmount = discount;
        this.totalPlatformFeeEndUser = totalPlatformFeeEndUser;
        // Discount applies to the slot subtotal only, not to the platform fee.
        this.totalSum = (totalAmount - discount) + totalPlatformFeeEndUser;

        //this.totalSum = this.bookings.reduce((sum, b) => sum + b.amount, 0);
        this.authService.getTenantDetailsBYTenantID(this.bookings[0].tenantId).subscribe(
          (response: any) => {
            this.tenant = response;
          }
        );
        this.authService.getUserDetails(this.bookings[0].email).subscribe(
          (response: any) => {
            this.user = response;
          }
        );
        // includeAddOns: a booking can contain addOn rows, whose names are looked up here too.
        this.authService.getAllProductsByTenantId(this.bookings[0].tenantId, true).subscribe(
          (response: any) => {
            this.products = response;
            this.updateBookingGroups();
            this.totalPlatformFeeEndUser = this.bookings.reduce((total, booking) => total + (Number(booking.platformFeeEndUser) || 0), 0);
            this.totalSum = (this.subTotal - this.discountAmount) + this.totalPlatformFeeEndUser;
          }
        );
        this.authService.getAllVenuesByTenantId(this.bookings[0].tenantId).subscribe(
          (response: any) => {
            this.venues = response;
          }
        );
      },
      (error) => {
        this.isLoading = false;
        this.bookingMessage = 'Unable to check the booking status. Please try again.';
        console.log("CB Response: ", error);
        console.log("Booking Failed for confirmationId: " + this.confirmationId);
      }
    );

  }

  cancelBooking(tpl: TemplateRef<any>) {
    this.modalService.open(tpl).result
      .then(result => {
        if (result === 'yes') {
          this.cancelBlockedSlots();   // 👉 your actual action
        }
      })
      .catch(() => {
        // modal dismissed, do nothing
      });
  }

  cancelBlockedSlots() {
    this.authService.cancelBooking(this.bookings[0].confirmationId).subscribe(
      (response: any) => {
        this.bookings = response;
        // add code to navigate to landing-page/transactions  after cancellation
        this.router.navigate(['/landing-page/transactions']);
      }
    );
  }

  getProductName(productId: number): string {
    return this.products.find(p => p.id === productId)?.productName ?? '';
  }

  formatTime(time: string): string {
    const match = String(time || '').trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
    if (!match) return time || '';

    let hour = Number(match[1]);
    const minute = match[2];
    const meridiem = match[3]?.toUpperCase();
    if (hour > 23 || Number(minute) > 59) return time;
    if (meridiem) {
      hour = (hour % 12) + (meridiem === 'PM' ? 12 : 0);
    }
    const suffix = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minute} ${suffix}`;
  }

  isAddOnBooking(booking: any): boolean {
    const product = this.products.find(item => item.id === booking.productId);
    const productType = String(product?.productType || '').trim().toLowerCase().replace(/[-_\s]/g, '');
    return booking.isAddOn === true
      || ['add-on', 'addon', 'accessory'].includes(String(booking.category || '').trim().toLowerCase())
      || ['addon', 'accessory'].includes(productType);
  }

  getAddOnQuantity(booking: any): number | null {
    let config = booking.config;
    if (typeof config === 'string') {
      try {
        config = JSON.parse(config);
      } catch {
        config = null;
      }
    }
    const quantity = Number(booking.quantity ?? config?.addOnQuantity ?? config?.accessoryQuantity);
    return Number.isInteger(quantity) && quantity > 0 ? quantity : null;
  }

  getAddOnUnitPrice(booking: any): number | null {
    const unitPrice = Number(booking.unitPrice);
    if (booking.unitPrice != null && Number.isFinite(unitPrice) && unitPrice >= 0) return unitPrice;
    const quantity = this.getAddOnQuantity(booking);
    return quantity ? (Number(booking.amount) || 0) / quantity : null;
  }

  private updateBookingGroups(): void {
    this.groupedSlots = this.groupSlotsByVenue(this.bookings.filter(booking => !this.isAddOnBooking(booking)));
    this.groupedAddOns = this.bookings.filter(booking => this.isAddOnBooking(booking));
  }

  // Group booking slots under a single product + venue header.
  groupSlotsByVenue(bookings: any[]): any[] {
    const groups = [];
    const indexByKey = new Map<string, number>();
    (bookings || []).forEach(b => {
      const key = b.productId + '_' + b.venueName;
      if (!indexByKey.has(key)) {
        indexByKey.set(key, groups.length);
        groups.push({ productId: b.productId, venueName: b.venueName, slots: [] });
      }
      groups[indexByKey.get(key)].slots.push(b);
    });
    return groups;
  }

  payNow() {
    if (this.isPaymentPending || this.isBillDeskPaymentActive || !this.bookings.length || this.bookingMessage) {
      return;
    }
    this.isPaymentPending = true;
    this.authService.getBookingByConfirmationId(this.bookings[0].confirmationId).subscribe(
      (response: any) => {
        const status = String(Array.isArray(response) ? response[0]?.bookingStatus || '' : '')
          .toLowerCase().replace(/\s+/g, '');
        if (status !== 'waitingforpayment') {
          this.isPaymentPending = false;
          this.bookingMessage = status === 'cancelled' || status === 'canceled'
            ? 'This booking has been cancelled by the admin.'
            : 'This booking is no longer available for payment.';
          return;
        }
        this.initiatePayment();
      },
      () => {
        this.isPaymentPending = false;
        alert('Unable to check the booking status. Please try again.');
      }
    );
  }

  private initiatePayment() {
    const request = {
      bookingId: this.bookings[0].confirmationId,
      browserInfo: this.utilService.getBrowserDetails()
    }

    // BillDesk
    this.authService.initiateBillDeskPaymentByBookingId(this.bookings[0].confirmationId, request).subscribe(
      (response: any) => {
        console.log("Response ", response);

        let bdOrderId = response.bdOrderId;
        let merchantId = response.mercid;
        let rdata = response.rdata;
        //window.location.href = `${response.url}?bdOrderId=${bdOrderId}&merchantId=${merchantId}&rdata=${rdata}`;

        var flow_config = this.utilService.billDeskFlowConfig(response);
        let image = "/assets/img/Logo.svg"
        var config = {
          responseHandler: (txn) => {
            console.log("callback received status:: ", txn.status)
            console.log("callback received response:: ", txn.response)
            if (String(txn.status) === '111' || String(txn.terminal_state) === '111') {
              console.log("Clicked on cancel button.")
              this.setBillDeskPaymentActive(false);
              this.navigateToPaymentStatus(this.bookings[0].confirmationId);
              return;
            }

            this.setBillDeskPaymentActive(false);
            this.navigateToPaymentStatus(this.bookings[0].confirmationId);
          },
          merchantLogo: image,
          flowConfig: flow_config,
          flowType: "payments"
        };
        this.setBillDeskPaymentActive(true);
        this.isPaymentPending = false;
        $("#myModal").modal('hide');
        this.utilService.launchBillDeskSdk(config);
      },
      (error: HttpErrorResponse) => {
        this.isPaymentPending = false;
        console.log(error);
        this.setBillDeskPaymentActive(false);
        if (error.error?.[0]?.bookingStatus == 'Unavailable') {
          $("#myModal").modal('hide');
          alert("selected slots are unavailable");
        } else if(error.error?.errors?.[0]?.field === "Payment_link") {
          alert("Transaction duration Expired!!!");
        } else {
          alert("Payment gateway failed. Please try again or after some time!!!!");
        }
      }
    )
  }

  private navigateToPaymentStatus(confirmationId: string): void {
    this.zone.run(() => {
      this.utilService.clearBillDeskUiState();
      this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_TRANSACTION_PAYMENT_STATUS + confirmationId);
    });
  }

  private setBillDeskPaymentActive(isActive: boolean): void {
    this.isBillDeskPaymentActive = isActive;

    if (isActive) {
      document.body.classList.add('billdesk-payment-active');
      return;
    }

    document.body.classList.remove('billdesk-payment-active');
    this.utilService.clearBillDeskUiState();
  }
}
